import { Instance, types } from 'mobx-state-tree'

export const Image = types
  .model('Image', {
    url: types.maybeNull(types.string)
  })

export type ImageInstance = Instance<typeof Image>
